import { cn } from "@/lib/cn";

export interface FlamingoMarkProps {
  className?: string;
  style?: React.CSSProperties;
  /** Decorative by default (hidden from a11y tree). Set a label to expose it. */
  alt?: string;
}

/**
 * The isolated flamingo line-art mark (from the PinkFlamingo.club lockup).
 * Used as a small brand accent or, at low opacity, a large background motif.
 */
export function FlamingoMark({ className, style, alt = "" }: FlamingoMarkProps) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- static brand SVG
    <img
      src="/brand/mark.svg"
      alt={alt}
      aria-hidden={alt ? undefined : true}
      draggable={false}
      className={cn("select-none", className)}
      style={style}
    />
  );
}
